import { useGetEncountersCurrentStatus } from '@/api/get-current-encounter-status';
import { EncounterStatusIdsType } from '@/api/api.schemas';

export function useIsVisitInProgress() {
  const { data, isFetching } = useGetEncountersCurrentStatus();
  const isVisitInProgress =
    data?.encounterStatusId != null &&
    data.encounterStatusId < EncounterStatusIdsType.ProviderCompleteWithErxTreatmentPlanUnread;
  return { isVisitInProgress, isFetching };
}
